// ============================================================================
// AUDIT TRAIL SERVICE
// ============================================================================

import { get } from '../client/axiosClient';
import { auditTrailEndpoints } from '../endpoints/auditTrail.endpoints';
import type { ApiResponse } from '../types';
import type { AuditTrailEntry } from '../types/auditTrail.types';

class AuditTrailService {
  async getAll(): Promise<ApiResponse<AuditTrailEntry[]>> {
    const response = await get<ApiResponse<AuditTrailEntry[]>>(auditTrailEndpoints.getAll());
    return response.data;
  }

  async getByRecord(recordType: string, recordId: string): Promise<ApiResponse<AuditTrailEntry[]>> {
    const response = await get<ApiResponse<AuditTrailEntry[]>>(auditTrailEndpoints.getByRecord(recordType, recordId));
    return response.data;
  }
}

export const auditTrailService = new AuditTrailService();
export default auditTrailService;
